import { useContext } from 'react';

import { HeaderContext } from './header-context';

function useHeader() {
  return useContext(HeaderContext);
}

export { useHeader };
